import { useRef } from "react";
import { createPortal } from "react-dom";

export interface IModalProps {
  visible: boolean;
  mask?: boolean;
  children?: React.ReactNode;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  maskClosable?: boolean;
}

const Modal: React.FC<IModalProps> = ({
  visible,
  mask,
  setVisible,
  children,
  maskClosable = false,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (
      maskClosable &&
      ref.current &&
      !ref.current.contains(event.target as Node)
    ) {
      setVisible && setVisible(false);
    }
  };

  return (
    visible &&
    createPortal(
      <div
        className={`w-full h-full flex items-center justify-center ${mask && "bg-#1F2533/36"
          } mobile-page`}
        onClick={handleClickOutside}
      >
        <div ref={ref}>{children}</div>
      </div>,
      document.body
      // document.getElementById("root") as HTMLElement
    )
  );
};

export default Modal;
